import { setAnalyticsCollectionEnabled } from "firebase/analytics";

export function setupCookieBot({ analytics }) {
    window.addEventListener('CookiebotOnConsentReady', () => {
        // eslint-disable-next-line no-undef
        if (Cookiebot && Cookiebot.consent.statistics) {
            console.debug("ENABLE FIREBASE");
            // Sintassi modulare: funzione(istanza, valore)
            setAnalyticsCollectionEnabled(analytics, true);
            console.debug("ENABLE FIREBASE - DONE");
        }
        else {
            console.debug("DISABLE FIREBASE");
            setAnalyticsCollectionEnabled(analytics, false);
            console.debug("DISABLE FIREBASE - DONE");
        }
    })
}
